import type { LucideIcon } from 'lucide-react';
import { Camera, Coffee, PenLine, Sparkles, Star, UtensilsCrossed } from 'lucide-react';

interface BlobIconSpec {
  Icon: LucideIcon;
  top: string;
  left: string;
  width: number;
  rotate?: number;
}

const BLOB_ICONS: BlobIconSpec[] = [
  { Icon: Coffee, top: '24%', left: '4%', width: 34, rotate: -8 },
  { Icon: UtensilsCrossed, top: '30%', left: '28%', width: 30, rotate: 4 },
  { Icon: PenLine, top: '26%', left: '50%', width: 28, rotate: -12 },
  { Icon: Camera, top: '28%', left: '72%', width: 32, rotate: 6 },
  { Icon: Coffee, top: '52%', left: '18%', width: 24, rotate: 10 },
  { Icon: PenLine, top: '54%', left: '62%', width: 22, rotate: -6 },
];

const SPARKLE_SPECS = [
  { top: '4%', left: '14%', size: 14 },
  { top: '8%', left: '42%', size: 11 },
  { top: '2%', left: '68%', size: 13 },
  { top: '14%', left: '82%', size: 10 },
];

interface CharacterHeroImageProps {
  src?: string;
  alt: string;
}

export default function CharacterHeroImage({ src, alt }: CharacterHeroImageProps) {
  return (
    <div className="dr-char-stage">
      <div className="dr-char-blob" aria-hidden="true">
        <div className="dr-char-blob-pattern">
          {BLOB_ICONS.map(({ Icon, top, left, width, rotate = 0 }, index) => (
            <span
              key={`${left}-${top}-${index}`}
              className="dr-char-blob-icon"
              style={{ top, left, width, transform: `rotate(${rotate}deg)` }}
            >
              <Icon size={width} strokeWidth={1.4} fill="currentColor" />
            </span>
          ))}
        </div>
      </div>

      {SPARKLE_SPECS.map(({ top, left, size }, index) => (
        <Star
          key={`sparkle-${index}`}
          className="dr-char-sparkle"
          style={{ top, left, width: size, height: size }}
          fill="#F0C040"
          color="#E8A820"
          strokeWidth={1.2}
          aria-hidden="true"
        />
      ))}

      {src ? (
        <img className="dr-char-img" src={src} alt={alt} />
      ) : (
        <Sparkles className="dr-char-fallback" size={48} color="var(--brand)" strokeWidth={1.4} />
      )}
    </div>
  );
}
